import { __rest } from "tslib";
import React, { useLayoutEffect, useState } from 'react';
import { default as useKeyboardNav } from "@pb/utils/reactHooks/useKeyboardNav";
import cn from 'classnames';
import { PinOutlineIcon, HMLogoIcon } from "../../ui/Icon";
import BodyText from "../../ui/Typography/texts/BodyText";
import SuggestionItem from './SuggestionItem';
import styles from './SuggestionsList.module.scss';
const icons = {
    PinOutlineIcon,
    HMLogoIcon,
};
const SuggestionsList = (_a) => {
    var { suggestions, onSuggestionConfirm, onClose, className, footerCredit, shouldShowNoLocationMatch, locationNotMatchingText } = _a, props = __rest(_a, ["suggestions", "onSuggestionConfirm", "onClose", "className", "footerCredit", "shouldShowNoLocationMatch", "locationNotMatchingText"]);
    const [shouldHandleConfirmation, setShouldHandleConfirmation] = useState(false);
    const [selectedSuggestion, setSelectedSuggestion] = useKeyboardNav({
        onSubmit: () => {
            setShouldHandleConfirmation(true);
        },
        onExit: () => {
            if (onClose) {
                onClose();
            }
        },
        length: suggestions.length,
    });
    const getSelectedSuggestionItem = () => {
        return suggestions[Number(selectedSuggestion)];
    };
    useLayoutEffect(() => {
        var _a;
        if (shouldHandleConfirmation) {
            if (onSuggestionConfirm) {
                const selectedSuggestionItem = getSelectedSuggestionItem();
                if (selectedSuggestionItem) {
                    onSuggestionConfirm({
                        selectedSuggestionID: selectedSuggestionItem.id,
                        text: selectedSuggestionItem.text,
                        isStore: selectedSuggestionItem.isStore,
                        lat: selectedSuggestionItem.lat,
                        lng: selectedSuggestionItem.lng,
                        id: (_a = selectedSuggestionItem.id) !== null && _a !== void 0 ? _a : '',
                        icon: selectedSuggestionItem.isStore ? 'HMLogoIcon' : 'PinOutlineIcon',
                    });
                }
            }
            setShouldHandleConfirmation(false);
        }
    }, [shouldHandleConfirmation]);
    const handleSuggestionClick = (selectedSuggestionIndex) => {
        // @ts-expect-error FIXME
        setSelectedSuggestion(selectedSuggestionIndex);
        setShouldHandleConfirmation(true);
    };
    if ((suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) === 0 && shouldShowNoLocationMatch) {
        return React.createElement(BodyText, null, locationNotMatchingText);
    }
    return (React.createElement("div", { className: cn(styles.container, className) },
        React.createElement("ul", Object.assign({ className: styles.list, role: "listbox", "aria-label": "Suggested Addresses", hidden: suggestions.length === 0, "data-testid": "suggestionsList" }, props), suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((suggestion, index) => {
            const { text, id, icon } = suggestion;
            return (React.createElement(SuggestionItem, { key: id, index: index, icon: icon, id: id, isActive: selectedSuggestion === index, onSuggestionClick: handleSuggestionClick }, text));
        })),
        (suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) > 0 && footerCredit && (React.createElement("div", { className: styles.credit }, footerCredit))));
};
export default SuggestionsList;
//# sourceMappingURL=SuggestionsList.js.map